import React from "react";

import { FormTextField } from "ui/Form";

const InformationContent = () => {
  return (
    <>
      <FormTextField name="name" label="License name" />
      <FormTextField name="description" label="Comment" />
    </>
  );
};

export default InformationContent;
